import React, { useMemo } from 'react'

import { ButtonClean, Fieldset } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'

import type { FormValues } from '../../hooks/useBadgeForm/types'
import { FormFields } from '../../hooks/useBadgeForm/types'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
}

export const AddAnotherStreak = ({ form }: Props) => {
  const lastStreak = form.values.memberStreakBadges[form.values.memberStreakBadges.length - 1]
  const lastMonthTo = lastStreak?.monthsTo

  const monthsTo = useMemo(() => {
    if (!lastMonthTo) return 0
    if (lastMonthTo === 60) return 0
    if (lastMonthTo === 0) return 0

    return lastMonthTo + 1
  }, [lastMonthTo])

  return (
    <Fieldset.Row>
      <ButtonClean
        label="Add another streak"
        onClick={() => {
          form.setFieldValue(
            FormFields.memberStreakBadges,
            form.values.memberStreakBadges.concat({
              emoji: {
                type: 'Emoji',
                emojiIcon: '😊',
              },
              borderColor: undefined,
              backgroundColor: 'rgba(0,0,0,0)',
              textColor: undefined,
              monthsFrom: lastMonthTo,
              monthsTo,
            }),
          )
        }}
      />
    </Fieldset.Row>
  )
}
